module.exports = __webpack_public_path__ + "static/media/profile.b9fc1577.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/profile.svg
// module id = 138
// module chunks = 0